<template>
  <div>
    <el-table class="rank_list" :data="teamRankingList" border>
      <el-table-column type="index" label="名次" width="100" align="center">
      </el-table-column>
      <el-table-column prop="teamName" label="团队名称"> </el-table-column>
      <el-table-column
        prop="captainName"
        label="队长姓名"
        width="150"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="score" label="分数" width="150" align="center">
        <template slot-scope="scope">
          {{ scope.row.score ? Number(scope.row.score.toFixed(2)) : 0 }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { teamRanking, memberRanking } from "@/api/teamGrade";
import { postList } from "@/api/post";
export default {
  data() {
    return {
      teamRankingList: [],
      memberRankingList: [],
      postList: [],
      postId: null,
    };
  },
  created() {
    this.getPostList();
  },
  computed: {
    memberPostRankingList() {
      return this.memberRankingList.filter((item) => {
        return item.postId == this.postId;
      });
    },
  },
  methods: {
    getRanking() {
      this.getTeamRanking();
      this.getMemberRanking();
    },
    getTeamRanking() {
      this.$loading.show();
      teamRanking({ classChapterId: this.$route.query.classChapterId }).then(
        (res) => {
          if (res.code == 0) {
            this.$loading.hide();
            this.teamRankingList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
    getMemberRanking() {
      this.$loading.show();
      memberRanking({ classChapterId: this.$route.query.classChapterId }).then(
        (res) => {
          if (res.code == 0) {
            this.$loading.hide();
            this.memberRankingList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
    getPostList() {
      postList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.postList = res.data;
          this.postId = res.data[0].postId;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .rank_list {
  &.mt {
    margin-top: 15px;
  }
  .is-leaf {
    color: #fff;
    background-color: #0088ff;
  }
}
</style>